import { Drawer } from "@/external/ensolvers-core-frontend-mui-v5/components/Main/Drawer";
import { useResponsive } from "@/hooks/useResponsive";
import { LazoUser } from "@/models/LazoUser";
import { drawerClasses, useTheme } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import LazoAIChatDrawerContent from "./LazoAIChatDrawerContent";
import LazoAIChatMobileModal from "./LazoAIChatMobileModal";

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  lazoUser: LazoUser;
};

export default function LazoAIChatDrawer(props: Props) {
  const theme = useTheme();
  const { isMobile, isTablet, isLargeScreen } = useResponsive();

  if (isMobile || isTablet) {
    return <LazoAIChatMobileModal {...props} />;
  }

  const drawerWidth = "100%";

  return (
    <Drawer
      hasFooter={false}
      ModalProps={{ keepMounted: false }}
      width={drawerWidth}
      anchor={"right"}
      variant={"permanent"}
      open={props.open}
      drawerExtraClosedMixin={() => ({
        width: 0,
        [`&.${drawerClasses.docked}`]: {
          width: 0,
        },
      })}
      paperExtraClosedMixin={() => ({
        width: 0,
        [`&.${drawerClasses.docked}`]: {
          width: 0,
        },
      })}
      sx={{
        display: "flex",
        width: "100%",
        position: "relative",
        "& .MuiBackdrop-root": {
          display: "none",
        },
        "& .MuiDrawer-paper": {
          position: "absolute",
          width: "100%",
          height: "100%",
          left: 0,
          top: 0,
          transition: "none !important",
          boxSizing: "border-box",
          overflowX: "hidden",
        },
        flexShrink: 0,
        whiteSpace: "normal",
        boxSizing: "border-box",
        zIndex: theme.zIndex.drawer + 2,
      }}
    >
      {props.open && <LazoAIChatDrawerContent setIsOpenDrawer={props.setOpen} lazoUser={props.lazoUser} />}
    </Drawer>
  );
}
